import {useDispatch, useSelector} from "react-redux";

import './style.scss';
import {useEffect} from "react";
import {restoreCurrentDistrictFromLocalStorage} from "../../actions/districts";

const CurrentDistrict = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(restoreCurrentDistrictFromLocalStorage())
  }, [dispatch]);

  const currentDistrict = useSelector((state) => state.districts.currentDistrict);

  return (
    <div className='current-district-container'>
      <span className='current-district-label'>Current District: </span>
      <span className='current-district-value'>{(currentDistrict) ? currentDistrict.name : 'Not Selected'}</span>
    </div>
  );
}

export default CurrentDistrict;